import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Jumpstart from "./pages/Jumpstart";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/othergames" element={<Jumpstart />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
